module.exports = __webpack_public_path__ + "img/SL7_4630-Bearbeitet.5380eb68.jpg";